import React from "react";
import { BlockSquare, TextInputMaterial } from "../common/StyledComponents";
import { Checkbox, DatePicker } from "antd";

const ImumProductTagAction = ({
  action,
  setAction,
  setGlobalTag,
  globalTag,
}) => {
  const [isEdit, setIsEdit] = React.useState(true);
  const default_colors = [
    "#0281B5",
    "#699635",
    "#FFCE31",
    "#03B0F7",
    "#D60D00",
    "#C28FEF",
    "#5C5C5C",
    "#89FF00",
    "#31FFDA",
    "#9E0000",
    "#FFA800",
    "#E2E2E2",
    "#5C821F",
    "#009AD9",
    "#8000FF",
  ];

  React.useEffect(() => {
    if (action.title === "") {
      setIsEdit(false);
    } else {
      setIsEdit(true);
    }
  }, []);

  return (
    <div
      className="d-flex 
      flex-column
       justify-content-between bg-white p-2 mb-1"
      style={{
        border: "1px solid #E9E9E9",
        borderRadius: 2,
      }}
    >
      <div className="d-flex align-items-center">
        <div className="text-black text-xs font-semi-bold">Color</div>
        <div className="d-flex align-items-center justify-content-between flex-1 ml-2">
          {default_colors.map((backgroundColor) => (
            <div
              className="cursor-pointer"
              onClick={() => {
                setAction((prev) => ({
                  ...prev,
                  values: {
                    ...prev.values,
                    color: backgroundColor,
                  },
                }));
              }}
            >
              <BlockSquare
                color={backgroundColor}
                border={backgroundColor == action.color ? "#696969" : "#B6B6B6"}
              />
            </div>
          ))}
        </div>
      </div>
      <TextInputMaterial
        autoFocus
        name="title"
        placeholder="Tag title"
        value={action.title}
        onChange={(e) => {
          const value = e.target.value;
          setAction((prev) => ({
            ...prev,
            values: {
              ...prev.values,
              title: value,
            },
          }));
        }}
      />
      <div className="mt-2" style={{ position: 'relative', zIndex: 1 }}>
        <div className="text-black text-xs font-semi-bold mb-1">Valid From</div>
        <DatePicker
          format="YYYY-MM-DD"
          placeholder="Select start date"
          value={action.valid_from}
          onChange={(date) => {
            setAction((prev) => ({
              ...prev,
              values: {
                ...prev.values,
                valid_from: date,
              },
            }));
          }}
          getPopupContainer={(trigger) => trigger.parentElement}
          style={{ width: '100%' }}
        />
      </div>
      <div className="mt-2" style={{ position: 'relative', zIndex: 1 }}>
        <div className="text-black text-xs font-semi-bold mb-1">Valid To</div>
        <DatePicker
          format="YYYY-MM-DD"
          placeholder="Select end date"
          value={action.valid_to}
          onChange={(date) => {
            setAction((prev) => ({
              ...prev,
              values: {
                ...prev.values,
                valid_to: date,
              },
            }));
          }}
          getPopupContainer={(trigger) => trigger.parentElement}
          style={{ width: '100%' }}
        />
      </div>
      {!isEdit && (
        <div className="d-flex flex-row mt-2">
          <Checkbox
            checked={globalTag}
            onChange={() => setGlobalTag((prev) => !prev)}
          >
            <span>
              Duplicate tag to {window.identifier == "technorama" ? "BB" : "TR"}{" "}
              IMUM
            </span>
          </Checkbox>
        </div>
      )}
    </div>
  );
};

export default ImumProductTagAction;
